import PropTypes from "prop-types";
import React from "react";
import DownloadItem from "./DownloadItem";
import * as styles from "./DownloadItemsStyles.module.scss";
import { downloadShape } from "./proptypes";

/**
 * Returns the rendered Products component.
 *
 * @param {Object} props The props to use.
 *
 * @returns {JSX.Element} The rendered products page.
 */
function DownloadItems( { downloads } ) {
	const itemCount = downloads.length;

	return (
		<div
			className={ styles.downloadItemsWrapper }
			// Never create more columns than there are downloads to put in them, so a
			// customer owning fewer products doesn't get needlessly narrow cards next to
			// an empty column. Values are strings on purpose: a "px" suffix would make
			// the repeat() in the stylesheet invalid.
			style={ {
				"--download-columns-sm": `${ Math.min( itemCount, 2 ) }`,
				"--download-columns-xl": `${ Math.min( itemCount, 3 ) }`,
				"--download-columns-2xl": `${ Math.min( itemCount, 5 ) }`,
			} }
		>
			{ downloads.map( download => {
				return <DownloadItem
					key={ download.name }
					download={ download }
				/>;
			} ) }
		</div>
	);
}

export default DownloadItems;

DownloadItems.propTypes = {
	downloads: PropTypes.arrayOf( downloadShape ).isRequired,
};

